import { EventCategory } from "@yn/utils";

// 基础配置 ，必须传递一个eventCategory 和 eventNo
export interface BaseEvent {
    eventCategory: EventCategory;
    eventNo: string;
}
export { EventCategory };
